export const VACANCY_POSITION = '/position/vacancy/' as const
export const VACANCY_POSITION_ALL = `${VACANCY_POSITION}all` as const
export const VACANCY_POSITION_ACTIVATE = `${VACANCY_POSITION}activate/` as const
export const VACANCY_POSITION_OPEN = `${VACANCY_POSITION}open/` as const
export const VACANCY_POSITION_CLOSE = `${VACANCY_POSITION}close/` as const
